import { glass, LandingSection, Reveal } from "@/components/landing/reveal";
import { GitCompareArrows, ListTodo, MessageSquare, Radio } from "lucide-react";

const CAPS = [
  {
    Icon: MessageSquare,
    title: "Design Reviews",
    body: "AllSpice-shaped from_ref ↔ to_ref. Agent findings must hang on the review object — empty chat is a failed review.",
  },
  {
    Icon: GitCompareArrows,
    title: "circuit_diff",
    body: "Pin-pair table plus sheet SVG on the change. A review accessory job, not a second IR and not a spatial redline overlay.",
  },
  {
    Icon: Radio,
    title: "Think Mission control",
    body: "The Think rail is mission control for the guided loop. Local-first agent; cloud Think is optional, not the default brain.",
  },
  {
    Icon: ListTodo,
    title: "Jobs",
    body: "import_kicad, checks, and circuit_diff drain in the open. Verify is a stage with a queue — not a hidden plugin.",
  },
] as const;

export function LandingProof() {
  return (
    <LandingSection
      id="proof"
      eyebrow="Proof / capabilities"
      title="What ships on the Mission."
      lede="Real objects on the project — Design Reviews, circuit_diff, Think, and Jobs — not a marketing canvas."
    >
      <div className="grid gap-3 sm:grid-cols-2">
        {CAPS.map((cap, i) => (
          <Reveal key={cap.title} delay={0.05 * i}>
            <article className={`${glass} flex h-full gap-4 p-5`}>
              <cap.Icon className="mt-0.5 size-4 shrink-0 text-falcon" aria-hidden />
              <div>
                <h3 className="mb-2 text-[16px] font-semibold text-white">{cap.title}</h3>
                <p className="m-0 text-[14px] leading-[1.55] text-white/64">{cap.body}</p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </LandingSection>
  );
}
